import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter)

import layout from "@/layout"

export const constantRoutes = [
	{
		path: '/',
		component: layout,
		redirect: "/main",
		children: [
      {
				path: '/main',
				name: 'Main',
				meta: {
					title: '首页',
          isNavbar: true,
				},
				component: () => import('@/views/main.vue')
			},
      {
        path: '/tutorial',
        name: 'Tutorial',
        meta: {
          title: '操作教程',
          requiresAuth: false,
          isNavbar: true,
          reqType: '1,2',
          reqIsLogin: '0',
        },
        component: () => import('@/views/tutorial.vue')
      },
      {
				path: '/evaluation',
        redirect: '/evaluation/index',
        name: 'evaluation',
				meta: {
					title: '生涯测评',
          requiresAuth: false,
          isNavbar: true,
				},
        component: () => import('@/views/router-view.vue'),
        children: [
          {
            path: 'index',
            meta: {
              title: '生涯测评',
              requiresAuth: false,
              isNavbar: false,
              openWindow: false,
            },
            component: () => import('@/views/evaluation/evaluationList.vue')
          },
          {
            path: 'detail',
            meta: {
              title: '生涯测评',
              requiresAuth: false,
            },
            component: () => import('@/views/evaluation/evaluationDetail.vue')
          },
          {
            path: 'answer',
            meta: {
              title: '生涯测评',
              requiresAuth: false,
            },
            component: () => import('@/views/evaluation/evaluationAnswer.vue')
          },
          {
            path: 'result',
            meta: {
              title: '生涯测评',
              requiresAuth: false,
            },
            component: () => import('@/views/evaluation/evaluationResult.vue')
          },
        ]
			},
      {
				path: '/recruit',
				name: 'Recruit',
				meta: {
					title: '人才招募',
          requiresAuth: false,
          isNavbar: true,
				},
				component: () => import('@/views/recruit.vue')
			},
      {
				path: '/signInTeacher',
				name: 'SignInTeacher',
				meta: {
					title: '智能系统(教师端)',
          requiresAuth: false,
          isNavbar: true,
          openWindow: false,
				},
				component: () => import('@/views/login/teacher.vue')
			},
      {
				path: '/signInStudent',
				name: 'SignInStudent',
				meta: {
					title: '智能系统(学生端)',
          requiresAuth: false,
          isNavbar: true,
          openWindow: false,
				},
				component: () => import('@/views/login/student.vue')
			},
		]
	},
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  //记录缓存的位置
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      return savePosition
    }else{
      return{x:0,y:0}
    }
  },
  routes: constantRoutes,
  base: process.env.BASE_URL,
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
